import React from "react";
import { useBnbSelector } from "../../../redux/store";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import { categorizeSpecs } from "../../../utils/typedUtils";
import * as ListStyles from "../../../../../../common-deprecated/styles/v2/toyota/globals/List";
import type { CertificationType } from "../../../../../../common-deprecated/constants";
import { CERTIFICATION_NONE } from "../../../../../../common-deprecated/constants";
import { getWLTPLabel } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { CommonSettingsType } from "../../../../../../common-deprecated/settings/fetchCommonSettings";
import SpecificationValue from "../common/SpecificationValue";
import type { BnbSettingsType } from "../../../redux/reducers/BnbSettingsReducer";
import { getEvDisclaimer } from "../../../utils/gradeEngineUtils";
import type { ModelGradeSpec } from "../../../../../../common-deprecated/types/CommonTypes";

const SpecDisclaimer = ({
    spec,
    engineDisclaimer,
    bnbSettings,
    commonSettings,
    electric,
}: {
    spec: ModelGradeSpec;
    engineDisclaimer: string;
    bnbSettings: BnbSettingsType;
    commonSettings: CommonSettingsType;
    electric: boolean;
}): JSX.Element | null => {
    const evDisclaimer = getEvDisclaimer(commonSettings, bnbSettings, spec.internalCode);
    const wltpDisclaimer = getWLTPLabel(commonSettings, spec.certification, electric);

    if (evDisclaimer) return <Popover showOnClick content={evDisclaimer} useHTML />;
    if (spec.certification === CERTIFICATION_NONE) return null;
    if (wltpDisclaimer) return <Popover showOnClick content={wltpDisclaimer} useHTML />;
    if (engineDisclaimer) return <Popover showOnClick content={engineDisclaimer} useHTML />;
    return null;
};

type EngineSpecsType = { specs: ModelGradeSpec[]; certification: CertificationType; electric: boolean };

const GradeEngineSpecs = ({ specs, certification, electric }: EngineSpecsType): JSX.Element => {
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const categories = categorizeSpecs(specs, commonSettings, bnbSettings);
    const engineDisclaimer = getWLTPLabel(commonSettings, certification, electric);

    return (
        <>
            {Object.entries(categories).map(([key, value]) =>
                !value.specs.length ? null : (
                    <React.Fragment key={key}>
                        {value.title && (
                            <Type.SmallHeading display="inline-block" mb={2}>
                                {value.title}
                            </Type.SmallHeading>
                        )}
                        <ListStyles.BulletList mt={0} role="list">
                            {value.specs.map((spec) => (
                                <ListStyles.BulletListItem key={spec.id} singleLine={!!spec}>
                                    {`${spec.name}: `}
                                    <SpecificationValue currentSpec={spec} allSpecs={value.specs} />
                                    <SpecDisclaimer
                                        spec={spec}
                                        engineDisclaimer={engineDisclaimer}
                                        bnbSettings={bnbSettings}
                                        commonSettings={commonSettings}
                                        electric={electric}
                                    />
                                </ListStyles.BulletListItem>
                            ))}
                        </ListStyles.BulletList>
                    </React.Fragment>
                ),
            )}
        </>
    );
};

export default GradeEngineSpecs;
